function parseData(data) {
  if ((!data) || data.length == 0) {
    return null;
  } else {
    return JSON.stringify(data);
  }
}


function parseSearchData(data) {
  if ((!data) || data.length == 0) {
    return null;
  } else {
    if (data.contractValue !== null)
      data.contractValue.map(o => (o.isSelected = false));
    return JSON.stringify(data);
  }
}

function parseRmSessionLogout(data) {
  if ((!data) || data.length == 0) {
    return null;
  } else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {

  const getContractsList = ({ inputParam, metaData }) =>
    api.getContractsList(inputParam, metaData)
      .then(parseSearchData)

  const startRMSession = ({ inputParam, metaData }) =>
    api
      .startRMSession(inputParam, metaData)
      .then(parseData);

  const rmSessionLogout = ({ inputParam, metaData }) =>
    api
      .rmSessionLogout(inputParam, metaData)
      .then(parseRmSessionLogout)
      .catch(parseRmSessionLogout);

  const rmLogout = ({ metaData }) =>
    api
      .rmLogout(metaData)
      .then(parseData)
      .catch(parseData);

  return {
    getContractsList,
    startRMSession,
    rmSessionLogout,
    rmLogout
  }
}

module.exports = serviceFactory;
